'use strict';

function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} // const isResumeSupported = window.Blob && window.Blob.prototype.slice;


var applyRequestHeaders = function applyRequestHeaders(req, headers) {
  if ((typeof headers === 'undefined' ? 'undefined' : _typeof(headers)) === 'object') {
    Object.keys(headers).forEach(function (key) {
      req.setRequestHeader(key, headers[key]);
    });
  }
};

var isFunction = function isFunction(maybeFunction) {
  return typeof maybeFunction === 'function';
};

var upload = exports.upload = function upload(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      file = _ref.file,
      _ref$fieldName = _ref.fieldName,
      fieldName = _ref$fieldName === undefined ? 'file' : _ref$fieldName,
      headers = _ref.headers,
      _ref$responseType = _ref.responseType,
      responseType = _ref$responseType === undefined ? 'json' : _ref$responseType,
      _ref$credentials = _ref.credentials,
      credentials = _ref$credentials === undefined ? false : _ref$credentials,
      _ref$withCredentials = _ref.withCredentials,
      withCredentials = _ref$withCredentials === undefined ? false : _ref$withCredentials,
      _ref$data = _ref.data,
      data = _ref$data === undefined ? new FormData() : _ref$data,
      onProgress = _ref.onProgress;

  return new Promise(function (resolve, reject) {
    if (file) {
      data.append(fieldName, file);
    }

    var req = new XMLHttpRequest();
    req.open('POST', url, true);
    req.withCredentials = withCredentials || credentials === 'include';
    req.responseType = responseType;
    applyRequestHeaders(req, headers);
    req.addEventListener('load', function () {
      var ok = req.status >= 200 && req.status < 300;
      resolve({
        body: req.response,
        status: req.status,
        ok: ok
      });
    });
    req.upload.addEventListener('progress', function (ev) {
      if (onProgress) {
        onProgress(ev);
      }
    });
    req.addEventListener('error', reject);
    req.addEventListener('abort', reject);
    req.send(data);
  });
};

var download = exports.download = function download(url) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      headers = _ref2.headers,
      _ref2$responseType = _ref2.responseType,
      responseType = _ref2$responseType === undefined ? 'blob' : _ref2$responseType,
      _ref2$credentials = _ref2.credentials,
      credentials = _ref2$credentials === undefined ? false : _ref2$credentials,
      _ref2$withCredentials = _ref2.withCredentials,
      withCredentials = _ref2$withCredentials === undefined ? false : _ref2$withCredentials,
      onProgress = _ref2.onProgress;

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.withCredentials = withCredentials || credentials === 'include';
    req.responseType = responseType;
    applyRequestHeaders(req, headers);
    req.addEventListener('load', function () {
      var ok = req.status >= 200 && req.status < 300;
      resolve({
        body: req.response,
        status: req.status,
        ok: ok
      });
    });
    req.addEventListener('progress', function (ev) {
      if (onProgress) {
        onProgress(ev);
      }
    });
    req.addEventListener('error', reject);
    req.addEventListener('abort', reject);
    req.send();
  });
};

var uploadObjectURL = function uploadObjectURL(url, objectURL, _ref3) {
  var filename = _ref3.filename,
      lastModified = _ref3.lastModified,
      type = _ref3.type,
      otherProps = _objectWithoutProperties(_ref3, ['filename', 'lastModified', 'type']);

  return download(objectURL).then(function (blob) {
    var file = new File([blob.body], filename, {
      lastModified: lastModified,
      type: type
    });
    return upload(url, _extends({
      file: file
    }, otherProps));
  });
};

exports.uploadObjectURL = uploadObjectURL;
exports.default = upload;